import React from 'react';
export const defaultIntlProvider = ({ children }) => React.createElement(React.Fragment, null, children);
export const defaultFormatter = ({ message }) => React.createElement(React.Fragment, null, message);
export const TranslateContext = React.createContext({
    translations: { locale: 'de' },
    intlProvider: defaultIntlProvider,
    formatter: defaultFormatter,
});
export const TranslateContextProvider = TranslateContext.Provider;
export const TranslateContextConsumer = TranslateContext.Consumer;
export function withTranslateContext(WrappedComponent) {
    return (props) => (React.createElement(TranslateContextConsumer, null, context => React.createElement(WrappedComponent, { ...props, translationsContext: context })));
}
//# sourceMappingURL=TranslateContext.js.map